// extracted by mini-css-extract-plugin
export default {"create":"create_create__7khsl"};